import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactFlow, {
  useNodesState,
  useEdgesState,
  Background,
  Controls,
  MiniMap,
  ReactFlowProvider,
} from "reactflow";
import "reactflow/dist/style.css";
import axios from "axios";
import {
  CompanyNode,
  SubsidiaryNode,
  JobNode,
  ScenarioNode,
  PersonNode,
  LogoNode,
  ServiceNode,
  NoteNode,
  MetricNode,
  HeaderBlock,
  HeroBlock,
  CtaBlock,
  SectionBlock,
  FooterBlock,
  FormBlock,
  InfoBlock,
  PriceBlock,
  LabelNode,
  LegendNode,
} from "@/components/diagram/CustomNodes";
import AnimatedEdge from "@/components/diagram/AnimatedEdge";

import { API_URL } from "@/utils/apiConfig";
const API = API_URL;

const nodeTypes = {
  company: CompanyNode,
  subsidiary: SubsidiaryNode,
  job: JobNode,
  scenario: ScenarioNode,
  person: PersonNode,
  logo: LogoNode,
  service: ServiceNode,
  note: NoteNode,
  metric: MetricNode,
  header: HeaderBlock,
  hero: HeroBlock,
  cta: CtaBlock,
  section: SectionBlock,
  footer: FooterBlock,
  form: FormBlock,
  info: InfoBlock,
  price: PriceBlock,
  label: LabelNode,
  legend: LegendNode,
};

const edgeTypes = {
  animated: AnimatedEdge,
};

function SharedViewInner() {
  const { shareId } = useParams();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/shared/${shareId}`);
        setTitle(data.title);
        if (data.nodes?.length > 0) setNodes(data.nodes);
        if (data.edges?.length > 0) setEdges(data.edges);
      } catch {
        setError("Lien de partage invalide ou expire");
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shareId]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div
          className="border-2 border-black p-8 shadow-[4px_4px_0px_0px_#000] text-center"
          data-testid="shared-error"
        >
          <p className="text-lg font-bold">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col" data-testid="shared-diagram-view">
      <header className="h-14 border-b-2 border-black bg-white flex items-center px-6">
        <h1 className="font-bold text-lg">{title}</h1>
        <span className="ml-3 font-mono text-[10px] border border-black px-1 uppercase bg-[#F4F4F4]">
          Lecture seule
        </span>
      </header>
      <div className="flex-1">
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          fitView
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
        >
          <Background gap={32} size={1} color="#80808030" />
          <Controls />
          <MiniMap nodeColor={(n) => n.data?.color || "#002FA7"} />
        </ReactFlow>
      </div>
    </div>
  );
}

export default function SharedDiagramView() {
  return (
    <ReactFlowProvider>
      <SharedViewInner />
    </ReactFlowProvider>
  );
}
